export default __webpack_public_path__ + "static/media/pages.0bec8f4c.png";